const getBaseUrl = () => {
    let url;
    switch(process.env.NODE_ENV) {
        case 'production':
            url = 'https://stat.mongolbank.mn/api/';
            break;
        case 'development':
            url = 'http://172.16.0.35:3000/api/';
            break;
        default:
            url = 'http://172.16.0.35:3000/api/';
            // url = 'https://stat.mongolbank.mn/api/';
    }

    return url;
}

export default getBaseUrl;